











































import {Component} from '@/shared/component';
import {AbstractEditVue} from '@/components/Abstract/AbstractEditVue';
import {BoisType} from '@/models';

import storeBoisType from '@/stores/modules/boisType';

import InputDatePicker from '@/components/Input/DatePicker.vue';
import CrudFournisseurSearch from '@/components/Crud/Fournisseur/Search.vue';

@Component({
	components: {
		InputDatePicker,
		CrudFournisseurSearch,
	}
})
export default class CrudBoisTypeEdit extends AbstractEditVue<BoisType> {
	public constructor() {
		super(
			storeBoisType,
			'Type d\'essence modifié',
			'Type d\'essence créé',
		);
	}
}
